import createApiCall from './endpoints'

// Authentification
export const getApiTokenCall = (username, password) => {
    return createApiCall({
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'GET_TOKEN',
        method: 'POST',
        data: {
            username: username,
            password: password
        }
    })
}

export const validateApiTokenCall = (token) => {
    return createApiCall({
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'VALIDATE_TOKEN',
        method: 'POST',
        headerParams:   {
            token: token
        },
    })
}

export const sessionGetCall = (token, data) => {
    return createApiCall({
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'SESSION_GET',
        method: 'POST',
        data: data,
        headerParams:   {
            token: token
        }
    })
}



export const sessionReloadCall = (token) => {
    return createApiCall({
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'SESSION_RELAOD',
        method: 'GET',
        headerParams:   {
            token: token
        }
    })
}

export const sessionRefreshCall = (token, data) => {
    return createApiCall({
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'SESSION_REFRESH',
        method: 'POST',
        data: data,
        headerParams:   {
            token: token
        }
    })
}

export const sessionAliveCall = (token) => {
    return createApiCall({
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'SESSION_ALIVE',
        method: 'GET',
        headerParams:   {
            token: token
        }
    })
}

export const sessionAliveBypassCall = (token) => {
    return createApiCall({
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'SESSION_ALIVE_BYPASS',
        method: 'GET',
        headerParams:   {
            token: token
        }
    })
}

export const sessionDeleteCall = (token) => {
    return createApiCall({
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'SESSION_DELETE',
        method: 'GET',
        headerParams:   {
            token: token
        }
    })
}

export const userLogoutCall = (token) => {
    return createApiCall({
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'LOGOUT',
        method: 'POST',
        headerParams:   {
            token: token
        }
    })
}




// Media
export const createMediaFileByUrlCall = (token, data)  => {
    return createApiCall({
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'MEDIAFILE_BY_URL',
        method: 'POST',
        data: data,
        headerParams:   {
            token: token
        }
    })
}
export const createMediaFileCall = (token, data) => {
    return createApiCall({
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'MEDIAFILE',
        method: 'POST',
        data: data,
        headerParams:   {
            token: token,
            multipart: true,
            // nonce: pmkinoClientVars.nonce
        }
    })
}

export const deleteMediaFileCall = (token, fileId) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'MEDIAFILE',
        method: 'DELETE',
        url: String(fileId),
        params: {
            force: true
        }
    })
}


export const updateMediaFileCall = (token, fileId, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'MEDIAFILE',
        method: 'POST',
        url: String(fileId),
        data: data
    })
}

export const getMediaFilesByMetaCall = (token, metaKey, metaValue, perPage = 10, offset = 0) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'MEDIAFILE',
        method: 'GET',
        params: {
            meta_key: metaKey,
            meta_value: metaValue,
            per_page: perPage,
            offset: offset
        }
    })
}


// Program
export const fetchProgramCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        signal: signal,
        apiEndpoint: 'PROGRAM_FETCH',
        method: 'GET'
    })
}

export const getProgramCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        signal: signal,
        apiEndpoint: 'PROGRAM_GET',
        method: 'GET'
    })
}


export const filterProgramCall = (token) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'PROGRAM_FILTER',
        method: 'POST'
    })
}

export const updateProgramCall = (token, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'PROGRAM_UPDATE',
        method: 'POST',
        data: data
    })
}

export const createProgramItem = (token, data) => {
    return createApiCall({
        headerParams: {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'PROGRAM_CREATE_ITEM',
        method: 'PUT',
        data: data
    })
}

// WP
export const getPagesCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'WP_PAGES',
        method: 'GET',
        signal: signal
    })
}

export const getServicePagesCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'WP_SERVICEPAGES',
        method: 'GET',
        signal: signal
    })
}

export const getMenuItemsCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'WP_MENUITEMS',
        method: 'GET',
        signal: signal
    })
}

export const getWPDataCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'WP_DATA',
        method: 'GET',
        signal: signal
    })
}

export const updateWPDataCall = (token, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'WP_DATA',
        method: 'PUT',
        data: data
    })
}


export const getPrintDataCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        signal: signal,
        apiEndpoint: 'PRINT_DATA_GET',
        method: 'GET'
    })
}

export const updatePrintDataCall = (token, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'PRINT_DATA_UPDATE',
        method: 'PUT',
        data: data
    })
}

export const getNewsletterDataCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        signal: signal,
        apiEndpoint: 'NEWSLETTER_LOCAL_DATA_GET',
        method: 'GET'
    })
}

export const updateNewsletterDataCall = (token, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'NEWSLETTER_LOCAL_DATA_UPDATE',
        method: 'PUT',
        data: data
    })
}

export const getAllNewsletters = (token, signal, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        signal: signal,
        apiEndpoint: 'NEWSLETTER_GET_ALL_NEWSLETTERS',
        method: 'POST',
        data : data
    })
}

export const updateNewsletterBasics = (token, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'NEWSLETTER_BASICS_UPDATE',
        method: 'POST',
        data : data
    })
}

export const createNewsletterStructure = (token, data)  => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'NEWSLETTER_STRUCTURE_CREATE',
        method: 'POST',
        data : data
    })
}

export const updateNewsletterStructure = (token, data)  => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'NEWSLETTER_STRUCTURE_UPDATE',
        method: 'POST',
        data : data
    })
}

export const deleteNewsletterStructure = (token, data)  => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'NEWSLETTER_STRUCTURE_DELETE',
        method: 'POST',
        data : data
    })
}

export const newsletterCampaignUpdate = (token, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'NEWSLETTER_CAMPAIGN_UPDATE',
        method: 'POST',
        data : data
    })
}

export const newsletterCampaignCreate = (token, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'NEWSLETTER_CAMPAIGN_CREATE',
        method: 'POST',
        data : data
    })
}

export const newsletterCampaignSend = (token, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'NEWSLETTER_CAMPAIGN_SEND',
        method: 'POST',
        data : data
    })
}

export const getMultisiteSelectorCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        signal: signal,
        apiEndpoint: 'MULTISITE_SELECTOR_GET',
        method: 'GET'
    })
}

export const updateMultisiteSelectorCall = (token, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'MULTISITE_SELECTOR_UPDATE',
        method: 'POST',
        data: data
    })
}

export const getRoutesDataCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        signal: signal,
        apiEndpoint: 'ROUTES_DATA_GET',
        method: 'GET',
    })
}

export const getCliDataCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        signal: signal,
        apiEndpoint: 'CLI_DATA_GET',
        method: 'GET',
    })
}

export const getEventsDataAllCall = (token, signal) => createApiCall({
    headerParams:   {
        token: token
    },
    baseURL: pmkinoClientVars.siteURL,
    signal: signal,
    apiEndpoint: 'EVENT_DATA_GET_ALL',
    method: 'GET',
})

export const updateEventsDataEventCall = (token, data) => createApiCall({
    headerParams:   {
        token: token
    },
    baseURL: pmkinoClientVars.siteURL,
    apiEndpoint: 'EVENT_DATA_EVENT_UPDATE',
    method: 'POST',
    data: data
})

export const sendEventDataEmailCall = (token, data) => createApiCall({
    headerParams:   {
        token: token
    },
    baseURL: pmkinoClientVars.siteURL,
    apiEndpoint: 'EVENT_DATA_SEND_MAIL',
    method: 'POST',
    data: data
})

export const deleteEventsDataEventCall = (token, data) => createApiCall({
    headerParams:   {
        token: token
    },
    baseURL: pmkinoClientVars.siteURL,
    apiEndpoint: 'EVENT_DATA_EVENT_DELETE',
    method: 'POST',
    data: data
})

export const getPushDataCall = (token, signal) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        signal: signal,
        apiEndpoint: 'PUSH_DATA_GET',
        method: 'GET'
    })
}

export const updatePushDataCall = (token, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'PUSH_DATA_UPDATE',
        method: 'PUT',
        data: data
    })
}

export const createPushCall = (token, data) => {
    return createApiCall({
        headerParams: {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'PUSH_CREATE',
        method: 'PUT',
        data: data
    })
}


